import API from "../configs/axiosInstance";

const getScorecardPageable = (data) => {
    return API({
        url: `account-service/v1/scorecards/pageable`,
        method: "POST",
        ...data
    })
}

const getScorecardHistory = (id) => {
    return API({
        url: `account-service/v1/scorecards/history/${id}`,
        method: "GET"
    })
}

const getDigitalFootprints = (parentDomainId) => {
    const isThirdParty = localStorage.getItem("userType") === "THIRD_PARTY";
    return API({
        url: isThirdParty
            ? `account-service/v1/third-party-portal/digital-footprint`
            : `account-service/v1/scorecards/${parentDomainId}/digital-footprint`,
        method: "GET"
    })
}

const hasFraudScorecard = (domainId) => {
    return API({
        url: `fraud-service/v1/fraud-domains/${domainId}/has-fraud`,
        method: "GET"
    })
}

const hasSSLScorecard = (domainId) => {
    return API({
        url: `account-service/v1/ssl-analyze/${domainId}/has-ssl`,
        method: "GET"
    })
}

const hasDehashedScorecard = (domainId) => {
    return API({
        url: `account-service/v2/new-domain-mail-leakages/${domainId}/has-dehashed`,
        method: "GET"
    })
}

const hasDarkWebScorecard = (domainId) => {
    return API({
        url: `account-service/v1/dark-web/${domainId}/has-data`,
        method: "GET"
    })
}

const startThirdPartyDomainScan = (data = {}) => {
    return API({
        url: `account-service/v1/domains/third-party-assessment`,
        method: 'POST',
        data
    })
}

const getMultipleSelectedScorecards = () => {
    return API({
        url: `account-service/v1/scorecards/third-party-assessment`,
        method: 'GET'
    })
}

const addMultipleSelectedScorecards = (data = {}) => {
    return API({
        url: `account-service/v1/scorecards/third-party-assessment`,
        method: 'POST',
        data
    })
}

const deleteMultipleSelectedScorecards = (data = {}) => {
    return API({
        url: `account-service/v1/scorecards/third-party-assessment`,
        method: 'DELETE',
        data
    })
}

const getAllExternalScorecards = () => {
    return API({
        url: `account-service/v1/scorecards/external-domain`,
        method: 'GET'
    })
}

const getThirdPartyAssessmentPageable = (params = {}, data = {}) => {
    const hasFilters = data && Object.keys(data).length > 0;
    return API({
        url: `account-service/v1/scorecards/third-party-assessment/pageable`,
        method: 'POST',
        data: hasFilters ? data : undefined,
        params
    })
}

const addSelectedScorecardWithContact = (data = {}) => {
    return API({
        url: `account-service/v1/scorecards/contact`,
        method: 'POST',
        data
    })
}

const deleteSelectedScorecardContact = (data) => {
  return API({
    url: `account-service/v1/scorecards/contact`,
    method: 'DELETE',
    data
  });
};

const sendThirdPartyMail = (data) => {
  return API({
    url: `account-service/v1/scorecards/thirdpartymail`,
    method: 'POST',
    data
  });
};

const getExternalHistory = () => {
    return API({
        url: `account-service/v1/scorecards/external-history`,
        method: "GET"
    })
}

const sendInitialConfirmation = (domainId) => {
    return API({
        url: `account-service/v1/third-party-confirmations/${domainId}/send-initial`,
        method: "POST"
    });
};

const resendConfirmation = (domainId) => {
    return API({
        url: `account-service/v1/third-party-confirmations/${domainId}/resend`,
        method: "POST"
    });
};

const rescanDomain = (domainId) => {
    return API({
        url: `account-service/v1/third-party-confirmations/${domainId}/rescan`,
        method: "POST"
    });
};

const getIndustryBenchmark = () => {
    return API({
        url: `account-service/v1/scorecards/industry-benchmark`,
        method: 'GET'
    })
}

const getConfirmationTemplate = () => {
    return API({
        url: `account-service/v1/confirmation-template`,
        method: "GET"
    });
};

const saveConfirmationTemplate = (data) => {
    return API({
        url: `account-service/v1/confirmation-template`,
        method: "PUT",
        data
    });
};

const deleteConfirmationTemplate = () => {
    return API({
        url: `account-service/v1/confirmation-template`,
        method: "DELETE"
    });
};

const scorecardService = {
    getScorecardPageable,
    getScorecardHistory,
    hasFraudScorecard,
    hasSSLScorecard,
    hasDehashedScorecard,
    getDigitalFootprints,
    startThirdPartyDomainScan,
    getMultipleSelectedScorecards,
    addMultipleSelectedScorecards,
    deleteMultipleSelectedScorecards,
    getAllExternalScorecards,
    getThirdPartyAssessmentPageable,
    addSelectedScorecardWithContact,
    deleteSelectedScorecardContact,
    sendThirdPartyMail,
    getExternalHistory,
    sendInitialConfirmation,
    resendConfirmation,
    rescanDomain,
    hasDarkWebScorecard,
    getIndustryBenchmark,
    getConfirmationTemplate,
    saveConfirmationTemplate,
    deleteConfirmationTemplate
};

export default scorecardService;
